import { checkoutInfoQuery, getPaymentMethodsQuery } from '../../hooks'
import { queryClient } from '../../state'
import { PaymentRouteLoader } from './payment-route.types'
import i18n from '../../i18n'

const NOT_WORKFLOW = 0

export const paymentRouteLoader: PaymentRouteLoader = async ({ request }) => {
  const url = new URL(request.url)
  const session = url.searchParams.get('session')

  if (
    session &&
    !queryClient.getQueryData(checkoutInfoQuery(session).queryKey)
  ) {
    const checkoutInfo = await queryClient.fetchQuery(checkoutInfoQuery(session))
    await queryClient.fetchQuery(getPaymentMethodsQuery(checkoutInfo.checkout_session, checkoutInfo.merchant_public_api_key, i18n.resolvedLanguage))

    if (checkoutInfo.workflow.length === NOT_WORKFLOW) {
      throw new Error('Error')
    }
    return checkoutInfo.workflow
  }

  return null
}
